


















import { computed, defineComponent, ref } from '@vue/composition-api';
import CompositeDialog from '@/components/composite/CompositeDialog.vue';
import PatientResultsScoringGVI from '@/components/patient/results/PatientResultsScoringGVI.vue';

// Import types ------------------------------------------------------------------------------------
import type { DialogId } from '@/plugins/podocore/modules/bus/bus.module';
// ------------------------------------------------------------------------------------------------
export default defineComponent({
  name: 'DialogAnalysisCommentUpdate',
  components: {
    CompositeDialog,
    PatientResultsScoringGVI
  },
  setup() {
    const dialogId: DialogId = 'analysis-GVI';
    const rDialog = ref<any>(null);

    const analysis = computed(() => rDialog?.value?.meta?.analysis);

    function closeDialog() {
      rDialog.value.close();
    }

    return {
      rDialog,
      dialogId,
      closeDialog,
      analysis
    };
  }
});
